/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useRef, useEffect } from 'react';
// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridgeWeak } from '@jira/platform__bridge/src';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { provideNavigationApi } from '@jira/platform__connect/src/core-jsapi-v5/js/spa-context/index.tsx';
import createBoardLegacy from '@jira/platform__legacy-create-board-legacy/src/index.tsx';
import {
	useLeftSidebarController,
	useLeftSidebarState,
} from '@jira/platform__controllers-layout/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';
// eslint-disable-next-line jira/restricted/unsafe-global-state-stores
import { useProjectSidebarNavigation } from '@jira/navigation-apps__sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { NavigationUIContainer } from '@jira/platform__controllers-navigation/src/components.tsx';
import { fromManagerKey } from '@jira/platform__services-item-managers/src/types.tsx';
import { useRouterActions } from '@atlassian/react-resource-router';
import { itemIds, viewIds } from '../common/constants.tsx';
import type { ImperativeAPIInterface, ImperativeAPIProps } from './types.tsx';

const ERROR_LOCATION = 'legacy.imperative-api';
export const ImperativeAPI = ({ getItemManager }: ImperativeAPIProps): React.JSX.Element => {
	const { collapseLeftSidebar, expandLeftSidebar } = useLeftSidebarController();
	const { refresh } = useProjectSidebarNavigation();
	const { push } = useRouterActions();
	const sidebarState = useLeftSidebarState();
	const sidebarRef = useRef(sidebarState);
	const refreshSidebarRef = useRef(refresh);

	const imperativeAPIRef = useRef<ImperativeAPIInterface>({
		viewIds,
		itemIds,
		expand: expandLeftSidebar,
		collapse: collapseLeftSidebar,
		isCollapsed: () => sidebarRef.current.isCollapsed,
		onCollapse: () => undefined,
		onCollapseStart: () => undefined,
		onCollapseEnd: () => undefined,
		onExpand: () => undefined,
		onExpandStart: () => undefined,
		onExpandEnd: () => undefined,
		onItemClick: () => undefined,
		setView: () => undefined,
		updateActiveView: () => undefined,
		setProjectRootView: () => undefined,
		getActiveViewItems: () => [],
		isInProjectContext: () => false,
		updateContext: () => undefined,
		updateData: () => {
			refreshSidebarRef.current();
		},
		getItemManager: (itemManagerKey) =>
			getItemManager(itemManagerKey).catch((e) => {
				log.safeErrorWithoutCustomerData(
					ERROR_LOCATION,
					`There was a problem getting "${fromManagerKey(itemManagerKey)}" item manager`,
					e,
				);
				throw e;
			}),
		createBoard: () => {
			createBoardLegacy();
		},
		modalOpen: () => undefined,
		modalClose: () => undefined,
		navigate: (url) => push(url),
	});

	sidebarRef.current = sidebarState;
	refreshSidebarRef.current = refresh;

	useEffect(() => {
		// eslint-disable-next-line jira/wrm/no-load-bridge
		loadBridgeWeak({
			name: 'jira/navigation/bridge',
		}).then((bridge) => {
			// @ts-expect-error - TS2571 - Object is of type 'unknown'.
			bridge(imperativeAPIRef.current);
		});

		provideNavigationApi({
			navigate: push,
		});
	}, [push]);

	return <NavigationUIContainer isGlobal />;
};
